export const machineCNCData = [
  {
    id: "1",
    make: "SIMPAC",
    name: "CNC 1호기",
    code: "CNC001",
    createdAt: "2025-06-01",
  },
  {
    id: "2",
    make: "SIMPAC",
    name: "CNC 2호기",
    code: "CNC002",
    createdAt: "2025-06-02",
  },
  {
    id: "3",
    make: "SIMPAC",
    name: "CNC 3호기",
    code: "CNC003",
    createdAt: "2025-06-03",
  },
];
